module.exports = __webpack_public_path__ + "static/media/profile.65bec85c.jpg";